
<div class="table-responsive" *ngIf="classes">

    <table class="custom-courses-summary-table table table-striped table-bordered align-middle">

        <thead class="custom-courses-summary-table-header text-center">

            <tr class="table-row">
                <th scope="col" colspan="3"></th>
                <th scope="col" colspan="3">Plazas</th>
            </tr>
            <tr class="table-row">
                
                <th  scope="col">Curso</th>
                <th  scope="col">Periodo</th>
                <th  scope="col">Precio</th>

                <th  scope="col">Totales</th>
                <th  scope="col" *ngIf="openEnrollments && showFreePlaces">Libres</th>
                <th  scope="col" *ngIf="openEnrollments && showOccupation">Ocupación</th>
            </tr>

        </thead>

        <tbody>
            
            <tr class="table-row" *ngFor="let class of classes">
                <td>
                    <span>{{ class.courseName }}</span>
                </td>
                <td>
                    <span>{{ class.scheduleDescription }}</span>
                </td>
                <td class="text-center">
                    <span>{{ class.price }} €</span>
                </td>
                <td class="text-center">
                    <span>{{ class.totalPlaces }}</span>
                </td>
                <td class="text-center" *ngIf="openEnrollments && showFreePlaces">
                    <span>{{ class.freePlaces }}</span>
                </td>
                <td class="text-center" *ngIf="openEnrollments && showOccupation">
                    <span class="material-icons" [ngClass]="getClassOccupation(class)">circle</span>
                </td>
            </tr>
            
        </tbody>
    
    </table>
    
</div>

